import React from 'react'
import { obtenermenupercepciones, obtenermenumovimientos, obtenermenuincidencias, obtenermenudeducciones, obtenermenutiporiesgo, obtenermenuramoseguro, obtenermenusecuelaconsecuencia, obtenermenucontrolincapacidad } from '../../Redux/PdimMenuDucks'
import { useSelector, useDispatch } from 'react-redux'
import { obtenerlotes } from '../../Redux/LotesDucks'
import { Grid, Typography, Divider } from '@mui/material'
import DialogoContenidorRegistroInci from './incidenciasregistro/DialogoContenidorRegistroInci'
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import MenuPerfil from '../loggin/MenuPerfil'
import BuscardorIn from './lote/BuscardorIn'
import BotonArchivoDispersion from '../archivo/BotonArchivoDispersion'
import Filtros from './lote/Filtros'
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const ContenedorIncidencias = (props) => {
  const { open } = props
  const { appbar } = props
  const dispatch = useDispatch()
  const [busqueda, setBusqueda] = React.useState('');
  const [rows2, setRows2] = React.useState([]);
  const [rows2ejercicio, setRows2ejercico] = React.useState([]);
  const nivelpri = sessionStorage.getItem('_sr3')
  const rows = useSelector(store => store.lote.lotes)
  var today = new Date();
  const ejerTemporal = sessionStorage.getItem('ej') || today.getFullYear();
  const ejercicion = parseInt(ejerTemporal)
  const [valueejer, setValueEjer] = React.useState(ejercicion);

  React.useEffect(() => {
    const obtenerInfo = () => {

      dispatch(obtenermenupercepciones())
      dispatch(obtenermenumovimientos())
      dispatch(obtenermenuincidencias())
      dispatch(obtenermenudeducciones())
      dispatch(obtenermenutiporiesgo())
      dispatch(obtenermenuramoseguro())
      dispatch(obtenermenusecuelaconsecuencia())
      dispatch(obtenermenucontrolincapacidad())
      dispatch(obtenerlotes())
    }
    obtenerInfo()
  }, [dispatch])

  React.useEffect(() => {
    const obtenerInfo = () => {
      filtrar(ejercicion)

    }
    obtenerInfo()
  }, [rows])

  React.useEffect(() => {
    const obtenerInfo = () => {
      filtrar2(busqueda)
    }
    obtenerInfo()
  }, [rows2ejercicio])

  const handleChange = e => {
    setBusqueda(e.target.value)
    filtrar2(e.target.value)
  }
  const handleChange2 = e => {
    setValueEjer(e.target.value)
    filtrar(e.target.value)
    sessionStorage.setItem('ej', (e.target.value))

  }
  const filtrar = (terminoBusqueda) => {
    var resultadoBusqueda = rows.filter((elemento) => {
      if (elemento.ejercicio === (terminoBusqueda)

      ) {
        return elemento
      }
    });
    setRows2ejercico(resultadoBusqueda)
  }

  const filtrar2 = (terminoBusqueda) => {
    var resultadoBusqueda = rows2ejercicio.filter((elemento) => {
      if (elemento.numeroperiodo.toString().toLowerCase().includes(terminoBusqueda.toString().toLowerCase()) ||
        elemento.descdepto.toString().toLowerCase().includes(terminoBusqueda.toString().toLowerCase()) ||
        elemento.idlote.toString().toLowerCase().includes(terminoBusqueda.toString().toLowerCase())
      ) {
        return elemento
      }
    });
    setRows2(resultadoBusqueda)
  }
  const dataejer = [...new Map(rows.map((m) => [m.ejercicio
    , m])).values()];


  const datahistorial = busqueda === '' ? rows2ejercicio : rows2

  return (
    <>
      <AppBar position="absolute" color='info' open={open} elevation={0}>
        <Toolbar
          sx={{
            pr: '24px', // keep right padding when drawer closed
          }}
        >
          <IconButton
            edge="start"
            color='success'
            aria-label="open drawer"
            onClick={appbar}
            sx={{
              marginRight: '36px',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Grid container alignItems="center" >
            <Grid item sm={12} xs={12} md={7} lg={8}>
              <BuscardorIn
                busqueda={busqueda}
                handleChange={handleChange}

              />
            </Grid>
            <Grid item sm={12} xs={12} md={5} lg={4}>
              <FormControl variant='outlined' sx={{ m: 1 }} fullWidth>
                <Select
                  fullWidth
                  size='small'
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={valueejer}
                  onChange={handleChange2}
                >
                  {dataejer.map((row, Index) => (
                    <MenuItem key={Index} value={row.ejercicio}>{row.ejercicio}</MenuItem>
                  ))}

                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <MenuPerfil />
        </Toolbar>
        <Divider />
      </AppBar>
      <br />
      <Grid container direction='row'>
        <Grid item sm={3} xs={8} md={3}>
          <Typography variant='h4'>Incidencias</Typography>

        </Grid>
        <Grid item md={9}>
          <Grid container justifyContent='flex-end' spacing={2}>
            <Grid item>
              <DialogoContenidorRegistroInci />
            </Grid>
            {nivelpri === '13' || nivelpri === '15' ?
              <Grid item>
                <BotonArchivoDispersion />
              </Grid> : null
            }

          </Grid>
        </Grid>

      </Grid> <br />
      <Filtros
        rows={datahistorial}
      />

    </>
  )
}

export default ContenedorIncidencias